import React from "react";
import { Steps } from "primereact/steps";
import { translate } from "./i18n";
import axios from "axios";

const getStoresFile = () => {
  if (
    window.location.host === "store-global.raidhut.com" ||
    window.location.host === "store-wydglobal.raidhut.com"
  ) {
    return "/data/stores-wydglobal.json";
  } else if (
    window.location.host === "store-br.raidhut.com" ||
    window.location.host === "store-wydbr.raidhut.com"
  ) {
    return "/data/stores-wydbr.json";
  } else if (window.location.host === "store-test.raidhut.com") {
    return "/data/stores-test.json";
  }
  return "/data/stores.json";
};

const idToServerName = (id) => {
  let serverNames = {
    origem: "Origem",
    odin: "Asgard",
    globalusd: "Global (USD)",
    globalbrl: "Global (BRL)",
    seasonusd: "Loki (USD)",
    seasonbrl: "Loki (BRL)",
  };
  return serverNames[id] ? serverNames[id] : "WYD";
};

const storeSteps = (index) => {
  return (
    <Steps
      activeIndex={index}
      model={[
        { label: translate("component.steps.step1") },
        { label: translate("component.steps.step2") },
        { label: translate("component.steps.step3") },
        { label: translate("component.steps.step4") },
      ]}
    />
  );
};

const IpHandler = {
  async getIpData() {
    const response = await axios.get("https://api.ipify.org/?format=json");
    return response.data.ip;
  },

  async getLocalationFromIp(ip) {
    const response = await axios.post(
      `https://toalha.tapiocahut.com/get-countryCode-from-ip`,
      { ip },
    );
    if (response.status === 200 && response.data.countryCode) {
      return response.data.countryCode;
    }
    return "";
  },

  getIpAddress: async function () {
    const isIpv4Format = (ip) => {
      const regex = /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)(\.(?!$)|$)){4}$/;
      return regex.test(ip);
    };

    const sources = [
      async () => {
        const response = await axios.get("https://api.ipify.org?format=json");
        return response.data.ip;
      },
      async () => {
        const response = await axios.get("https://ipv4.jsonip.com");
        return response.data.ip;
      },
      async () => {
        const response = await axios.get("https://ipv4.icanhazip.com/");
        return response.data.trim();
      },
      async () => {
        const response = await axios.get("https://checkip.amazonaws.com/");
        return response.data.trim();
      },
    ];

    for (const source of sources) {
      try {
        const ip = await source();
        if (ip && isIpv4Format(ip)) {
          const country_code = await this.getLocalationFromIp(ip);
          console.log(country_code, ip);
          return { ip, country_code };
        }
      } catch (error) {
        // continue to next source
      }
    }

    throw new Error("Unable to retrieve a valid IPv4 address from any source.");
  },
};

export { idToServerName, storeSteps, getStoresFile, IpHandler };
